import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f032930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-wrap" }
const _hoisted_2 = { class: "main-navigation desktop" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Website Design & Layout")
const _hoisted_6 = { class: "sub-menu" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Form Submissions")
const _hoisted_8 = { class: "sub-menu" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("My Account")
const _hoisted_10 = { class: "sub-menu" }
const _hoisted_11 = { class: "main-navigation mobile" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "mobile-menu"
}
const _hoisted_15 = { class: "menu" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Menu", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Website Design & Layout")
const _hoisted_18 = { class: "sub-menu" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Form Submissions")
const _hoisted_20 = { class: "sub-menu" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("My Account")
const _hoisted_22 = { class: "sub-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "logo",
        src: _ctx.logo,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
      }, null, 8, _hoisted_3),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
        }, "Dashboard"),
        _createElementVNode("li", null, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/website-design-and-layout/homepage')))
            }, "Homepage")
          ])
        ]),
        _createElementVNode("li", null, [
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/contact-forms')))
            }, "Website Contact Form"),
            _createElementVNode("li", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/onboarding-forms')))
            }, "Service Onboarding Forms")
          ])
        ]),
        _createElementVNode("li", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/services')))
        }, "Services"),
        _createElementVNode("li", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/portfolio')))
        }, "Portfolio"),
        _createElementVNode("li", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/posts')))
        }, "Posts"),
        _createElementVNode("li", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/my-account')))
        }, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.signOut()))
            }, "Sign Out")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("img", {
          class: "logo",
          src: _ctx.logo,
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/')))
        }, null, 8, _hoisted_13),
        _createElementVNode("div", {
          class: "ri-menu-2-line",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showMobileMenu = true))
        }),
        (_ctx.showMobileMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("p", {
                  class: "close-menu",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showMobileMenu = false))
                }, "X Close Menu"),
                _hoisted_16,
                _createElementVNode("li", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/'), _ctx.showMobileMenu = false))
                }, "Dashboard"),
                _createElementVNode("li", null, [
                  _hoisted_17,
                  _createElementVNode("ul", _hoisted_18, [
                    _createElementVNode("li", {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push('/website-design-and-layout/homepage'), _ctx.showMobileMenu = false))
                    }, "Homepage")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _hoisted_19,
                  _createElementVNode("ul", _hoisted_20, [
                    _createElementVNode("li", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/contact-forms')))
                    }, "Website Contact Form"),
                    _createElementVNode("li", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$router.push('/onboarding-forms')))
                    }, "Service Onboarding Forms")
                  ])
                ]),
                _createElementVNode("li", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/services'), _ctx.showMobileMenu = false))
                }, "Services"),
                _createElementVNode("li", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.push('/portfolio'), _ctx.showMobileMenu = false))
                }, "Portfolio"),
                _createElementVNode("li", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$router.push('/posts'), _ctx.showMobileMenu = false))
                }, "Posts"),
                _createElementVNode("li", {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$router.push('/my-account'), _ctx.showMobileMenu = false))
                }, [
                  _hoisted_21,
                  _createElementVNode("ul", _hoisted_22, [
                    _createElementVNode("li", {
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.signOut(), _ctx.showMobileMenu = false))
                    }, "Sign Out")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}